export default {
  methods: {
    focusChanged(e, componentType = null) {
      const { id, value, parentNode } = e.target;
      if (document.activeElement.id === id) {
        this.removePlaceHolder(
          parentNode.parentElement.id,
          value,
          componentType,
          `${e.type}-${e.key}`,
        );
      }
    },

    addGTMEvent(eventType, value, componentType, keyType) {
      setTimeout(() => {
        this.removePlaceHolder(eventType, value, componentType);
      }, 0);
      // eslint-disable-next-line
      this.$gtm.push({
        category: this.formType,
        event: 'gaEvent',
        action: keyType || 'click',
        label: eventType,
      });
    },

    removePlaceHolder(eventType, value, componentType) {
      if (componentType !== 'check') {
        const inputGroup = document.getElementById(eventType);
        const input = document.getElementById(`${eventType}FormInput`);
        this.$nextTick(() => {
          this.domAddGroupTitle(inputGroup, componentType);
        });
        if (!value && componentType !== 'select') {
          input.focus();
        }
      }
    },

    removeTitleGroup(eventType, value, componentType) {
      if (componentType !== 'check') {
        const inputGroup = document.getElementById(eventType);
        if (!value || componentType === 'select') {
          this.domAddPlaceHolder(inputGroup, componentType);
        }
      }
    },

    domAddGroupTitle(inputGroup, componentType) {
      if (componentType !== 'select') {
        inputGroup?.classList.remove('form-group-placeHolder');
        inputGroup?.classList.add('form-group-title');
      } else {
        inputGroup?.childNodes[0].classList.add('form-group-title');
      }
    },

    domAddPlaceHolder(inputGroup, componentType) {
      if (componentType !== 'select') {
        inputGroup.classList.add('form-group-placeHolder');
        inputGroup.classList.remove('form-group-title');
      } else {
        inputGroup.childNodes[0].classList.remove('form-group-title');
      }
    },
  },
};
